<template>
  <CCheckButton v-model:active="model" class="c-check-box">
    <slot name="option">{{ placeholder }}</slot>
  </CCheckButton>
</template>

<script setup lang="ts">
  import CCheckButton from '../CCheckButton.vue';

  defineProps<{
    placeholder?: string;
  }>();

  const model = defineModel<boolean>();
</script>

<style lang="scss">
  .c-check-box {
    &.c-button {
      justify-content: start;
      border: none;
      font-weight: inherit;
    }
  }
</style>